// This module is used by the frontend and by the gatsby build!
// Therefore shadowing this source won't work - we have to use a feature-toggle USE_RESTRICTED_PAGE_PATTERN (Default is enabled)

/** Those access types will trigger the generation of a blurred page */
export const RESTRICT_PAGES_WITH_ACCESS_TYPES = ["logged_in_show", "logged_in_groups"];

/**
 * Will return true if the page is not public accessible
 * @param item A page or teaser item
 */
export function isPageAccessRestricted(item) {
  if (typeof process.env.USE_RESTRICTED_PAGE_PATTERN !== 'undefined' && process.env.USE_RESTRICTED_PAGE_PATTERN === "false") {
    return false;
  }
  if (!item || !item.access || !item.access.type) {
    return false;
  }
  return RESTRICT_PAGES_WITH_ACCESS_TYPES.indexOf(item.access.type) >= 0;
}
